import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import MenuOutlinedIcon from '@mui/icons-material/MenuOutlined';
import {
  Box,
  Button,
  Drawer, IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Typography,
} from '@mui/material';
import React, { useState } from 'react';

import { LogoMark2cIconC } from '@/assets';
import { globalTypes } from '@/shared/duck';
import { muiPalette } from '@/shared/general-theme';

interface IWelcomeMobileHeaderProps {
  login: () => void;
  menuItems: globalTypes.MenuItemList[];
}

export const WelcomeMobileHeader: React.FC<IWelcomeMobileHeaderProps> = ({ login, menuItems }) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const handleDrawerToggle = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const drawer = (
    <Box sx={{ textAlign: 'center' }}>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          p: 2,
        }}
      >
        <LogoMark2cIconC
          style={{
            height: '1.5rem',
          }}
        />
        <Typography
          variant='body1'
          component='div'
          sx={{
            ml: '1.5rem',
            fontWeight: 800,
            letterSpacing: '-0.02em',
            color: muiPalette.primary.main,
          }}
        >
          PLATYPUS<span style={{ color: muiPalette.tertiary.main }}>.</span>
        </Typography>

        <IconButton
          onClick={handleDrawerToggle}
          sx={{ color: muiPalette.grey[50] }}
        >
          <CloseOutlinedIcon />
        </IconButton>
      </Box>

      <List>
        {menuItems.map((item) => (
          <ListItem key={item.title} disablePadding>
            <ListItemButton sx={{ textAlign: 'center' }} onClick={item.itemAction}>
              <ListItemText
                primary={item.title}
                slotProps={{ primary: { sx: { color: muiPalette.grey[50] } } }}
              />
            </ListItemButton>
          </ListItem>
        ))}
        <ListItem disablePadding sx={{ mt: 2, justifyContent: 'center' }}>
          <Button
            variant='contained'
            color='primary'
            startIcon={<AccountCircleOutlinedIcon />}
            sx={{
              borderRadius: '100px',
              px: 3,
              boxShadow: `0 4px 14px ${muiPalette.primary.main}40`,
            }}
            onClick={login}
          >
            Login
          </Button>
        </ListItem>
      </List>
    </Box>
  );

  return (
    <>
      <Box sx={{ display: { xs: 'flex', md: 'none' }, alignItems: 'center' }}>
        <Button
          variant='contained'
          color='primary'
          sx={{ mr: 4, borderRadius: '100%', p: '0.3rem', minWidth: 'initial' }}
          onClick={login}
        >
          <AccountCircleOutlinedIcon />
        </Button>

        <IconButton
          color='inherit'
          aria-label='open drawer'
          edge='start'
          onClick={handleDrawerToggle}
          sx={{ color: muiPalette.grey[50] }}
        >
          <MenuOutlinedIcon />
        </IconButton>
      </Box>

      <Drawer
        anchor='right'
        open={mobileMenuOpen}
        onClose={handleDrawerToggle}
        ModalProps={{
          keepMounted: true,
        }}
        sx={{
          display: { xs: 'block', md: 'none' },
          '& .MuiDrawer-paper': {
            boxSizing: 'border-box',
            width: '90%',
            maxWidth: '30rem',
            backgroundColor: muiPalette.background.dark,
          },
        }}
      >
        {drawer}
      </Drawer>
    </>
  );
};

export default WelcomeMobileHeader;